import { TableHeaderData } from "../../investorOverview/types";

export const PortfolioHealthHeaderData: TableHeaderData[] = [
    {
        id: "parameter",
        label: "Parameter",
        align: "left",
        isSortable: false
    },
    {
        id: "value",
        label: "Value",
        align: "left",
        isSortable: false
    }
]

export const AssetAllocationGuidelinesHeaderData: TableHeaderData[] = [
    {
        id: "assetClass",
        label: "Asset Class",
        align: "left",
        isSortable: false
    },
    {
        id: "limits",
        label: "Limits",
        align: "center",
        isSortable: false
    },
    {
        id: "actualPortfolio",
        label: "Actual Portfolio",
        align: "center",
        isSortable: false
    },
]

export const contributionAnalysisTableHeaderData = (type: string): TableHeaderData[] => {
    return ([
        {
            id: type === "sector" ? "sector" : "issuer",
            label: type === "sector" ? "Sector" : "Issuer",
            align: "left",
            isSortable: false
        },
        {
            id: "portfolioWeight",
            label: "Portfolio Weight",
            align: "center",
            isSortable: false
        },
        {
            id: "portfolioReturns",
            label: "Portfolio Returns",
            align: "center",
            isSortable: false
        },
        {
            id: "cumulativeWeight",
            label: "Cumulative Weight",
            align: "center",
            isSortable: false,
            headerTableCellStyle: {
                width: "100%",
            }
        },
    ])
}
export const PrudentialNormsHeaders: TableHeaderData[] = [
    {
        id: "assetClass",
        label: "Asset Class",
        align: "left",
        isSortable: false
    },
    {
        id: "limits",
        label: "Limits",
        align: "center",
        isSortable: false
    },
    {
        id: "actualPortfolio",
        label: "Actual Portfolio",
        align: "center",
        isSortable: false
    },
]

export const MaxAllocationMFHeaders: TableHeaderData[] = [
    {
        id: "guidelines",
        label: "Guidelines",
        align: "left",
        isSortable: false
    },
    {
        id: "limits",
        label: "Limits",
        align: "center",
        isSortable: false
    },
    {
        id: "current",
        label: "Current",
        align: "center",
        isSortable: false
    },
]


export const HoldingPeriodTableHeader: TableHeaderData[] = [
    {
        id: "schemeName",
        label: "SCHEME NAME",
        align: "left",
        isSortable: false
    },
    {
        id: "saleDate",
        label: "SALE DATE",
        align: "left",
        isSortable: false
    },
    {
        id: "quantity",
        label: "Quantity",
        align: "center",
        isSortable: false
    },
]

